import { createSelector } from 'reselect';
import dashboardTagUrl from 'components/Menu/dashboard-tag-url';
import { STATUSES } from 'reducers/menu/index.js';

export const selectMenu = (state) => state.menu;

export const selectMenuData = createSelector(selectMenu, (menu) => menu.data);

export const selectCurrentMenuItem = createSelector(
  selectMenuData,
  (_state, props) => props.match.path,
  (menuData, path) => {
    const item = menuData.find((item) => {
      const url = dashboardTagUrl[item.dashboardTag] || `/${item.dashboardTag.toLowerCase()}`;
      return url === path;
    });

    return item;
  },
);

export const selectMenuStatus = createSelector(selectMenu, (menuStatus) => menuStatus.status);

export const isMenuLoading = createSelector(
  selectMenuStatus,
  (status) => status === STATUSES.IDLE || status === STATUSES.PENDING,
);

export const selectMenuIdle = createSelector(selectMenu, ({ idle }) => idle);

export const selectIsMenuVisible = createSelector(selectMenu, ({ isVisible }) => isVisible);
